import bowser from 'bowser'
import { connect } from 'react-redux'
import { Component } from 'macguffin'
import {
  toggleMute, toggleMuteMusic, toggleMuteSFX, toggleSpaceToSpin, play,
  setSkipFeature, attemptToSpin, setSavedSettings, toggleSingleSetting
} from 'macguffin/redux/actions'
import Toggle from './toggle'
import { getFromLocalStorage, setToLocalStorage, isLocalStorageAvailable } from 'macguffin/Utils'

/**
 * This are the default settings that every game share.
 */
@connect(state => ({ base: state.base }), {
  toggleMute,
  toggleMuteSFX,
  toggleMuteMusic,
  toggleSpaceToSpin,
  toggleSingleSetting,
  play,
  attemptToSpin,
  setSkipFeature,
  setSavedSettings,
})
export default class DefaultSettings extends Component {
  /**
   * Saves the settings to the server upon unmounting.
   */
  componentWillUnmount() {
    this.props.setSavedSettings()
  }

  /**
   * Toggles the value of the provided setting to true/false.
   * If the setting doesn't exist yet, it will create it and set it to true.
   * @param {string} settingName - The name of the setting that should be toggled.
   */
  toggleSingle = (settingName) => {
    this.props.toggleSingleSetting(settingName)
  }

  toggleIntro = () => {
    const currentSetting = getFromLocalStorage('skipIntro')
    setToLocalStorage('skipIntro', currentSetting === 'false' || !currentSetting)
    this.forceUpdate()
  }

  /**
   * Renders a DOM element containing a set of default toggle settings.
   * @returns {*}
   */
  render() {
    const { props } = this
    const { base } = props
    const { muted, mutedSFX, mutedMusic, settings, soundAvailable, hasSplash, hasIntro, soundsLoaded } = base
    const { spaceToSpin, noSplashScreen } = settings

    return (
      <div className="content-block">
        <div className="toggles">
          {
            /**
             * TODO: macguffin update needed
             * To simplify and make compatible new sound settings page with the state, fix in mcg lib:
             * - top sound button is now ALL SOUNDS ON/SOME OFF, and not MUTED/SOME ON ... mcg state should follow the logic
             * - initial state of mutedSFX and mutedMusic should be true when muted is true
            */
          }
          <div className="section-title-sound">
            <span>{this.t('settings.sections.sound')}</span>
          </div>
          <div className="divider empty" />
          <Toggle name="sound" toggled={!muted && !mutedSFX && !mutedMusic} disabled={!soundAvailable}
            setting={() => {
              if (muted || (!mutedSFX && !mutedMusic)) {
                this.props.toggleMute()
              } else if (mutedMusic) {
                this.props.toggleMuteMusic()
              } else {
                this.props.toggleMuteSFX()
              }
            }} />
          <Toggle name="sfx" toggled={!mutedSFX && !muted} disabled={!soundAvailable}
            setting={!soundsLoaded && muted && !mutedSFX && !mutedMusic ? this.props.toggleMuteMusic : this.props.toggleMuteSFX} />
          <Toggle name="music" toggled={!mutedMusic && !muted} disabled={!soundAvailable}
            setting={!soundsLoaded && muted && !mutedMusic && !mutedSFX ? this.props.toggleMuteSFX : this.props.toggleMuteMusic} />
          <div className="section-title-game">
            <span>{this.t('settings.sections.game')}</span>
          </div>
          <div className="divider empty" />
          {!bowser.mobile && !bowser.tablet && (
            <Toggle name="spaceToSpin" toggled={spaceToSpin}
              setting={() => { this.toggleSingle('spaceToSpin') }} />
          )}
          {hasSplash && (
            <Toggle name="showSplash" toggled={!noSplashScreen}
              setting={() => { this.toggleSingle('noSplashScreen') }} />
          )}
          {isLocalStorageAvailable() && hasIntro && (
            <Toggle name="showIntro" toggled={getFromLocalStorage('skipIntro') !== 'true'}
              setting={this.toggleIntro} />
          )}
        </div>
      </div>
    )
  }
}
